import Icon from '../components/Icon.vue'

Icon.register({
  gamepad: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M480 96c88.4 0 159.9 71.6 159.9 160s-71.6 160-160 160c-44.7 0-85.2-18.4-114.2-48h-91.5c-29 29.6-69.4 48-114.2 48-88.4 0-160-71.6-160-160s71.6-160 160-160h320zM256 276v-40c0-6.6-5.4-12-12-12h-52v-52c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52h-52c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12zM440 344c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM520 264c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gamepad.js
// module id = 1378
// module chunks = 0